import { render } from "./ConsultantSurveys.vue?vue&type=template&id=a0e58086"
import script from "./ConsultantSurveys.vue?vue&type=script&lang=js"
export * from "./ConsultantSurveys.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__